import { Component } from "react";
import { bool, func, string } from "prop-types";
import styled from "styled-components/macro";
import { rem } from "polished";

import { colors, fonts } from "../../../styles/Styles.variables";

class Switch extends Component {
  render() {
    const {
      checked,
      children,
      id,
      labelChecked = "On",
      labelUnchecked = "Off",
      ...rest
    } = this.props;

    return (
      <Control>
        <Input {...rest} id={id} />
        <Label
          htmlFor={id}
          checked={checked}
          labelChecked={labelChecked}
          labelUnchecked={labelUnchecked}
        >
          {children}
        </Label>
      </Control>
    );
  }
}

Switch.propTypes = {
  checked: bool,
  id: string.isRequired,
  labelChecked: string,
  labelUnchecked: string,
  onChange: func,
};

Switch.defaultProps = {
  checked: false,
};

const trackOffset = 18;
const trackWidth = 84;
const trackWidthRem = rem(`${trackWidth}px`);
const controlWidth = rem(`${trackWidth + trackOffset}px`);
const toggleSize = 30;
const toggleSizeRem = rem(`${toggleSize}px`);
const toggleRadius = rem(`${toggleSize / 2}px`);
const togglePosOff = rem(`${toggleSize + trackOffset}px`);
const toggleOffset = rem("4px");

const Control = styled.div`
  display: block;
  padding-left: ${controlWidth};
  padding-top: ${rem("3px")};
  position: relative;
`;

const Input = styled.input.attrs(props => ({
  type: "checkbox",
}))`
  left: 0;
  opacity: 0;
  position: absolute;
  top: 0;
  z-index: -1;
`;

const Label = styled.label`
  display: block;
  height: ${toggleSizeRem};
  position: relative;

  :before {
    background-color: ${({ checked }) =>
      checked ? colors.green400 : colors.gray600};
    border-radius: ${toggleRadius};
    box-shadow: inset 0 0 ${rem("2px")} 0 ${colors.black};
    color: ${colors.white};
    content: "${({ checked, labelChecked, labelUnchecked }) =>
      checked ? labelChecked : labelUnchecked}";
    display: block;
    font-weight: ${fonts.weights.bold};
    height: ${toggleSizeRem};
    left: -${controlWidth};
    line-height: ${toggleSizeRem};
    padding-left: ${({ checked }) => (checked ? toggleSizeRem : toggleOffset)};
    padding-right: ${({ checked }) => (checked ? toggleOffset : toggleSizeRem)};
    pointer-events: all;
    position: absolute;
    text-align: center;
    text-transform: uppercase;
    transition: background-color 0.3s ease-in-out;
    top: 0;
    width: ${trackWidthRem};
  }

  &:after {
    background-color: ${colors.white};
    border-radius: ${toggleRadius};
    box-shadow: 0 0 ${rem("4px")} 0 ${colors.black};
    content: "";
    display: block;
    height: ${toggleSizeRem};
    left: 0;
    width: ${toggleSizeRem};
    position: absolute;
    top: 0;
    transform: translateX(
      -${({ checked }) => (checked ? controlWidth : togglePosOff)}
    );
    transition: transform 0.3s ease-in-out;
  }
`;

export default Switch;
